export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SecondaryButton.vue?vue&type=template&id=22711658&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SecondaryButton.vue?vue&type=template&id=22711658&scoped=true&
// module id = 139
// module chunks = 0